import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { Link } from 'react-router';
import { withPageContainerStyles } from '@/common/components/page-layout';
import useWebpWithPngFallback from '@/common/hooks/use-webp-with-png-fallback';
import { aboutEVsSupportUrl } from '@/catalog/constants/support-urls';

export interface EVHeroVehicleProps {
  prefix: string;
}

export default function EVHeroVehicle({ prefix }: EVHeroVehicleProps) {
  const imageSrc = useWebpWithPngFallback(`${prefix}/ev-hero-kia-niro.webp`);

  return (
    <div className="flex min-h-[670px] min-w-full flex-col-reverse bg-flexcar-neutral100 lg:min-h-[351px] lg:flex-row lg:justify-end">
      <div
        className={withPageContainerStyles(
          // Note: This is half of the page container width 1440px / 2 = 720px
          'flex w-full max-w-[720px] flex-col gap-4 py-10 lg:justify-center lg:pr-10'
        )}
      >
        <h1 className="text-flexcar-neutral1">Experience an EV</h1>
        <p className="text-flexcar-neutral1">
          With zero tailpipe emissions and unparalleled acceleration, electric vehicles
          have plenty to offer. Flexcar provides the unique opportunity for you to
          experience an EV without the commitment or cost of buying one.
        </p>
        <Link
          to={aboutEVsSupportUrl}
          target="_blank"
          rel="noreferrer"
          className={cn('link-body w-fit', 'font-bold')}
        >
          Learn more about electric vehicles {'->'}
        </Link>
      </div>
      <div
        style={
          {
            '--ev-vehicle-desktop': `linear-gradient(90deg, ${colors.neutral100} 0%, transparent 124px), url(${imageSrc})`,
            '--ev-vehicle-mobile': `linear-gradient(0deg, ${colors.neutral100} 0%, transparent 66px), url(${imageSrc})`,
          } as React.CSSProperties
        }
        className="relative min-h-[388px] min-w-full bg-[image:var(--ev-vehicle-mobile)] bg-cover bg-[position:0%_0%,_center_right_20%] bg-no-repeat sm:bg-[position:0%_0%,_center_right_10%] lg:min-h-[351px] lg:min-w-[50%] lg:bg-[image:var(--ev-vehicle-desktop)] lg:bg-[position:0%_0%,_center_right_25%]"
      />
    </div>
  );
}
